<template>
  <transition
    name="dialog-fade"
    @after-leave="afterLeave"
    @after-enter="afterEnter"
  >
    <div
      :class="[
        'sj-dialog-wrapper',
        {
          'sj-dialog-wrapper--flex': !draggable
        }
      ]"
      v-show="visible"
      @mousedown.self="handleClickOutside"
      v-if="showWrapper"
    >
      <DialogInner
        v-bind="$attrs"
        :title="title"
        :draggable="draggable"
        :dragSelector="dragSelector"
        @confirm="handleConfirm"
        @close="handleClose"
      >
        <slot name="header" slot="header"></slot>
        <slot></slot>
        <slot name="footer" slot="footer"></slot>
      </DialogInner>
    </div>
    <DialogInner
      v-else
      v-show="visible"
      v-bind="$attrs"
      :title="title"
      :draggable="draggable"
      :dragSelector="dragSelector"
      @confirm="handleConfirm"
      @close="handleClose"
      style="position: fixed;"
    >
      <slot name="header" slot="header"></slot>
      <slot></slot>
      <slot name="footer" slot="footer"></slot>
    </DialogInner>
  </transition>
</template>

<script>
/**
 * dialog组件，使用了utils中的popup mixin作为基础
 * 此弹窗为屏蔽式弹窗，并包含一定的基础内容，用于自定义内容的大型弹窗
 */
import Popup from "../../../utils/popup/index.js";
import DialogInner from "./DialogInner";

export default {
  name: "SjDialog",
  mixins: [Popup],
  components: {
    DialogInner
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    showWrapper: {
      type: Boolean,
      default: true
    },
    closeOnClickOutside: {
      type: Boolean,
      default: true
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    closeOnEsc: {
      type: Boolean,
      default: true
    },
    beforeClose: {
      type: Function,
      default: done => {
        done();
      }
    },
    draggable: {
      type: Boolean,
      default: false
    },
    dragSelector: {
      type: String,
      default: ".sj-dialog-header"
    }
  },
  data() {
    return {
      originOverflow: null
    };
  },
  beforeDestroy() {
    if (this.visible) {
      this.handleClose();
    }
  },
  methods: {
    /**
     * handleClickOutside - 点击非dialog区域时的操作
     */
    handleClickOutside() {
      if (this.closeOnClickOutside) {
        this.handleClose();
      }
    },
    /**
     * handleClose - 点击close或取消按钮时的操作
     */
    handleClose() {
      const done = () => {
        this.$emit("update:visible", false);
        this.$emit("close");
      };
      if (this.lockScroll) {
        document.body.style.overflow = this.originOverflow;
      }
      this.beforeClose(done);
    },
    /**
     * handleConfirm - 点击确定按钮时的操作
     */
    handleConfirm() {
      this.$emit("confirm");
    },
    /**
     * afterEnter - 显示回调的内部函数
     */
    afterEnter() {
      if (this.lockScroll) {
        this.originOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
      }
      this.$emit("shown");
      this.push();
    },
    /**
     * afterEnter - 关闭回调的内部函数
     */
    afterLeave() {
      this.$emit("closed");
      this.pop();
    }
  }
};
</script>

<style lang="less">
@dialog-background-color-wrapper: rgba(0, 0, 0, 0.2);

.dialog-fade-enter-active {
  animation: dialog-fade-in 0.4s;
}

.dialog-fade-leave-active {
  animation: dialog-fade-out 0.4s;
}

@keyframes dialog-fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes dialog-fade-out {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.sj-dialog-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0;
  background-color: @dialog-background-color-wrapper;
  &.sj-dialog-wrapper--flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
